import type React from "react";
import { Link } from "react-router-dom";
import type { Diary } from "@/types/diary";
import { formatDate } from "@/utils/date";

interface DiaryItemProps {
	diary: Diary;
}

const DiaryItem: React.FC<DiaryItemProps> = ({ diary }) => {
	// 内容を100文字で切り取り、必要に応じて「...」を追加
	const truncatedContent =
		diary.content.length > 100
			? `${diary.content.substring(0, 100)}...`
			: diary.content;

	return (
		<div className="bg-white p-4 rounded shadow hover:shadow-md transition-shadow">
			<h3 className="text-xl font-semibold mb-2">{diary.title}</h3>
			<p className="text-sm text-gray-500 mb-2">
				{formatDate(diary.createdAt)}
			</p>
			<p className="text-gray-700 mb-4 line-clamp-3">{truncatedContent}</p>
			<div className="flex justify-between items-center">
				<Link
					to={`/webapp/diary/${diary.id}`}
					className="text-blue-500 hover:underline"
				>
					続きを読む
				</Link>
				<span className="text-sm text-gray-500">
					最終更新: {formatDate(diary.updatedAt)}
				</span>
			</div>
		</div>
	);
};

export default DiaryItem;
